import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OfflineDataSyncErrorObject } from "../../../models/upload-management.schema";

@Component({
  selector: "app-data-sync-alert-dialog",
  templateUrl: "./data-sync-alert-dialog.component.html",
  styleUrls: ["./data-sync-alert-dialog.component.scss"],
  standalone: false
})
export class DataSyncAlertDialogComponent {
  offlineDataSyncErrorObjectList: Array<OfflineDataSyncErrorObject>;

  constructor(
    public dialogRef: MatDialogRef<DataSyncAlertDialogComponent, { result: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.offlineDataSyncErrorObjectList = data.offlineDataSyncErrorObjectList;
  }

  confirm(): void {
    this.dialogRef.close({ result: true });
  }
}
